import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { Panel } from "@/components/extranet/StatusBadge";
import { http, idr, errMsg, fmtDate } from "@/lib/api";

export default function GroupCommission({ month, basis, setDownload, onOpen }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    http.get("/extranet/commission-summary", { params: { month, basis } }).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [month, basis]);
  useEffect(() => { setDownload({ url: "/extranet/commission-summary", name: `komisi-grup-${month}.csv` }); }, [month, setDownload]);

  const T = data?.total;
  return (
    <Panel title={`Ringkasan komisi grup · ${fmtDate(`${month}-01`, "MMMM yyyy")}`} testid="group-report-table">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#F8FAFC] text-left text-xs uppercase text-slate-500">
            <tr><th className="px-5 py-2.5">Properti</th><th>Komisi % saat ini</th><th className="text-right">Booking</th><th className="text-right">Malam kamar</th><th className="text-right">Harga kamar</th><th className="text-right">Komisi terutang</th><th className="text-right">Net ke hotel</th><th className="pr-5 text-right">Invoice</th></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {!data && <tr><td colSpan={8} className="px-5 py-8 text-center text-slate-400">Memuat...</td></tr>}
            {data?.rows.map((r) => (
              <tr key={r.property_id} data-testid={`group-row-${r.property_id}`} className={r.bookings ? "" : "text-slate-400"}>
                <td className="px-5 py-3"><button data-testid={`group-open-${r.property_id}`} onClick={() => onOpen(r.property_id)} className="text-left font-semibold text-[#006CE4] hover:underline">{r.name}</button><span className="block text-xs text-slate-400">{r.city}</span></td>
                <td>{r.commission_percent}%</td><td className="text-right">{r.bookings}</td><td className="text-right">{r.room_nights}</td>
                <td className="text-right">{idr(r.room_revenue)}</td><td className="text-right font-semibold text-[#1F5F8B]">{idr(r.commission)}</td><td className="text-right">{idr(r.net)}</td>
                <td className="pr-5 text-right"><Link data-testid={`group-invoice-${r.property_id}`} to={`/extranet/invoice/${r.property_id}/${month}`} className="text-xs font-semibold text-[#006CE4] hover:underline">Lihat</Link></td>
              </tr>
            ))}
          </tbody>
          {T && (
            <tfoot className="border-t-2 border-slate-200 bg-[#F8FAFC] font-bold" data-testid="group-total">
              <tr><td className="px-5 py-3">TOTAL ({data.rows.length} properti)</td><td /><td className="text-right">{T.bookings}</td><td className="text-right">{T.room_nights}</td>
                <td className="text-right">{idr(T.room_revenue)}</td><td className="text-right text-[#1F5F8B]" data-testid="group-total-commission">{idr(T.commission)}</td><td className="text-right">{idr(T.net)}</td><td /></tr>
            </tfoot>
          )}
        </table>
      </div>
    </Panel>
  );
}
